import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './components/auth/AuthProvider';
import AuthorizedApolloProvider from './components/AuthorizedApolloProvider.component';
import Spinner from './components/Spinner.component';
import './lib/i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <AuthorizedApolloProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AuthorizedApolloProvider>
    </Suspense>
  </React.StrictMode>,
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
